import { motion } from "framer-motion";
import { ASSETS } from "../content";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => (
  <div className="fixed top-3 sm:top-4 inset-x-0 z-50 flex justify-center px-3 pointer-events-none">
    <motion.nav
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.6 }}
      className="pointer-events-auto flex items-center gap-0.5 sm:gap-1 rounded-full border border-white/10 bg-[#132441]/70 backdrop-blur-xl px-1.5 py-1.5 sm:px-2 sm:py-2 max-w-full"
      data-testid="floating-nav"
    >
      <img src={ASSETS.regLogo} alt="REG — Real Estate Guy" className="h-8 w-8 sm:h-9 sm:w-9 rounded-full object-cover bg-white mx-1 shrink-0" data-testid="nav-logo" />
      {[["LEARN", "learn"], ["HOST", "host"], ["FAQ", "faq"]].map(([label, id]) => (
        <button
          key={id}
          data-testid={`nav-${id}-link`}
          data-cta
          onClick={() => scrollTo(id)}
          className="mono text-[11px] sm:text-[13px] tracking-wider sm:tracking-widest text-white hover:text-[#FFC631] px-2 sm:px-3 py-2 transition-colors duration-200 whitespace-nowrap"
        >
          {label}
        </button>
      ))}
      <button
        data-testid="nav-register-cta"
        data-cta
        onClick={() => scrollTo("register")}
        className="mono text-[11px] sm:text-[13px] font-bold tracking-wider sm:tracking-widest bg-[#FFE100] text-[#12264A] rounded-full px-3 sm:px-4 py-2 btn-slide whitespace-nowrap"
      >
        REGISTER ↗
      </button>
    </motion.nav>
  </div>
);

export const MobileCTA = () => (
  <div className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-[#132441]/85 backdrop-blur-xl border-t border-white/10 p-3" data-testid="mobile-sticky-cta">
    <button
      data-testid="mobile-cta-button"
      onClick={() => scrollTo("register")}
      className="w-full bg-[#FFE100] text-[#12264A] font-bold text-sm uppercase tracking-wide py-4 rounded-md btn-slide active:scale-[0.99]"
    >
      ✓ RESERVE MY FREE SEAT
    </button>
  </div>
);
